import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ConfirmModal } from 'src/modules/shared';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';

@Component({
  selector: 'app-company-detail',
  templateUrl: './company-detail.component.html',
  styleUrls: ['./company-detail.component.scss'],
})
export class CompanyDetailComponent implements OnInit {
  projectId: string;
  projectFields: Array<any> = [
    // { name: 'Company Users', route: 'user' }
  ];
  // companyType = 'business_name';
  companyType = JSON.parse(window.localStorage.getItem('user')).organizationId
    .jpaContractor?.companyType?.optionId;
  ownershipType = JSON.parse(window.localStorage.getItem('organization'))
    .jpaContractor.ownershipType.optionId;
  menus: Array<any> = [
    {
      name: 'Company Profile',
      route: 'profile',
      permission: 'COMPANY_PROFILE_MANAGEMENT',
    },
    this.ownershipType !== 'foreign_owned' && {
      name: 'Official Documents',
      route: 'document',
      permission: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
    },
    this.ownershipType !== 'foreign_owned' && {
      name: 'Supporting  Documents',
      route: 'supporting-document',
      permission: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
    },
    {
      name: 'Ownership Structure',
      route: 'ownership-structure',
      permission: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
    },
    {
      name:
        this.companyType === 'business_name_actual' ||
        this.companyType === 'business_name'
          ? 'Owners Of Business'
          : 'Directors',
      route: 'director',
      permission: 'SHAREHOLDERS_MANAGEMENT',
    },
    {
      name: 'Shareholders',
      route: 'shareholder',
      permission: 'SHAREHOLDERS_MANAGEMENT',
    },
    this.ownershipType !== 'foreign_owned' && {
      name: 'Tax Clearance Records',
      route: 'record',
      permission: 'TCC_RECORD_MANAGEMENT',
    },
    {
      name: 'Equipment',
      route: 'equipment',
      permission: 'EQUIPMENT_MANAGEMENT',
    },
  ];
  success: any;
  error: any;
  pending: boolean;
  permissions;
  organizationId!: string;
  companyAffiliateTypes!: any[];
  allAffiliateTypes!: any[];
  isRestrictedEntity: boolean = false;

  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private companyOwnershipService: CompanyOwnershipService
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    const organization = JSON.parse(
      window.localStorage.getItem('organization')
    );
    if (organization.restrictedApplicationId) {
      this.isRestrictedEntity = true;
    }
    if (window.localStorage.getItem('user')) {
      let authTokenPermission = JSON.parse(localStorage.getItem('permissions'));
      // this.permissions = JSON.parse(window.localStorage.getItem("permission"));
      this.permissions = authTokenPermission;
    }
    this.activatedRoute.parent.params.subscribe((params) => {
      this.projectId = params['id'];
    });
  }

  checkPermission(id: string, action: string): boolean {
    if (
      this.permissions.filter((res) => res.permissionId === id)[0] &&
      this.permissions.filter((res) => res.permissionId === id)[0][action] ===
        'true'
    ) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit(): void {
    this.getAffiliateTypes(this.companyType);
    this.getAllAfiliateTypes();
  }

  getAffiliateTypes(companyTypeId: string) {
    if (companyTypeId == 'public_company_limited_by_shares_actual') {
      companyTypeId = 'limited_liability';
    }
    this.companyOwnershipService
      .getOwnershipsForCompanyType({ companyTypeId: companyTypeId })
      .subscribe(
        (res: any[]) => {
          this.companyAffiliateTypes = res;
          console.log(this.companyAffiliateTypes);
        },
        (error) => {
          console.log(error);
          this.pending = false;
        }
      );
  }

  getAllAfiliateTypes() {
    this.companyOwnershipService.getOwnershipTypes().subscribe(
      (res: any[]) => {
        this.allAffiliateTypes = res;
        let t = setInterval(() => {
          if (this.pending == false) {
            clearInterval(t);
          }

          if (this.companyAffiliateTypes) {
            this.companyAffiliateTypes.forEach((companyAffiliateType) => {
              this.allAffiliateTypes.every((affiliateType) => {
                if (
                  companyAffiliateType.ownershipType == affiliateType.optionName
                ) {
                  companyAffiliateType.ownershipTypeId = affiliateType.optionId;
                  return false;
                }
                return true;
              });
            });
            this.getMenu();
            this.removeForeignOwnedMenus();
            console.log(
              this.companyAffiliateTypes,
              'this.companyAffiliateTypes'
            );
            this.pending = false;
            clearInterval(t);
          }
        }, 200);
      },
      (error) => {
        this.pending = false;
        console.log(error);
      }
    );
  }

  getAffiliateTypesFromMenu() {
    this.menus.forEach((menu) => {
      if (menu.permission) {
        if (this.checkPermission(menu.permission, 'read')) {
          this.projectFields.push(menu);
        }
      } else {
        this.projectFields.push(menu);
      }
    });
  }
  getMenu() {
    this.menus = [
      {
        name: 'Company Profile',
        route: 'profile',
        permission: 'COMPANY_PROFILE_MANAGEMENT',
      },
      this.ownershipType !== 'foreign_owned' && {
        name: 'Official Documents',
        route: 'document',
        permission: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
      },
      this.ownershipType !== 'foreign_owned' && {
        name: 'Supporting Documents',
        route: 'supporting-document',
        permission: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
      },
      ...this.companyAffiliateTypes.map((affiliateType) => ({
        name: affiliateType.ownershipType,
        route: 'ownership-structure',
        type: affiliateType.ownershipTypeId,
        isTitleCase: true,
      })),
      this.ownershipType !== 'foreign_owned' && {
        name: 'Tax Clearance Records',
        route: 'record',
        permission: 'TCC_RECORD_MANAGEMENT',
      },
      {
        name: 'Equipment',
        route: 'equipment',
        permission: 'EQUIPMENT_MANAGEMENT',
      },
    ].filter(Boolean); // Filters out falsey values, including `false` and `undefined`.

    this.getAffiliateTypesFromMenu();
  }

  removeForeignOwnedMenus() {
    if (this.ownershipType === 'foreign_owned') {
      this.menus = this.menus.filter(
        (menu) =>
          ![
            'Official Documents',
            'Supporting Documents',
            'Tax Clearance Records',
          ].includes(menu.name)
      );
    }
  }

  // getMenu() {
  //   this.menus = [
  //     {
  //       name: 'Company Profile',
  //       route: 'profile',
  //       permission: 'COMPANY_PROFILE_MANAGEMENT',
  //     },
  //     this.ownershipType !== 'foreign_owned' && {
  //       name: 'Official Documents',
  //       route: 'document',
  //       permission: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
  //     },
  //     this.ownershipType !== 'foreign_owned' && {
  //       name: 'Supporting  Documents',
  //       route: 'supporting-document',
  //       permission: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
  //     },
  //     // {
  //     //   name: 'Ownership Structure',
  //     //   route: 'ownership-structure',
  //     //   permission: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
  //     // },
  //     ...this.companyAffiliateTypes.map((affiliateType: any) => ({
  //       name: affiliateType.ownershipType,
  //       route: 'ownership-structure',
  //       type: affiliateType.ownershipTypeId,
  //       isTitleCase: true,
  //     })),
  //     // ...this.companyAffiliateTypes.map((affiliateType: any) => ({
  //     //   name: affiliateType.ownershipType,
  //     //   route: 'personnel',
  //     //   type: affiliateType.ownershipTypeId,
  //     //   isTitleCase: true,
  //     // })),
  //     this.ownershipType !== 'foreign_owned' && {
  //       name: 'Tax Clearance Records',
  //       route: 'record',
  //       permission: 'TCC_RECORD_MANAGEMENT',
  //     },
  //     {
  //       name: 'Equipment',
  //       route: 'equipment',
  //       permission: 'EQUIPMENT_MANAGEMENT',
  //     },
  //   ];
  //   this.getAffiliateTypesFromMenu();
  // }

  goBack() {
    console.log('here');
    this.location.back();
  }
}
